import { Apis, Enums, Helpers, Store } from "utils";

export interface ICalendarService {
  find(): Promise<any>;
  insert(
    eTitle: string | null,
    eNotes: string | null,
    startTime: Date,
    endTime: Date,
    isPrimary: boolean | null,
    isConfirmed: boolean | null,
    appointmentId: number | null,
    ids?: {
      clinicId?: number;
      providerId?: number;
    }
  ): Promise<any>;
  update(
    eId: number,
    eTitle: string | null,
    eNotes: string | null,
    startTime: Date,
    endTime: Date,
    isPrimary: boolean | null,
    isConfirmed: boolean | null,
    appointmentId: number | null
  ): Promise<any>;
  delete(eId: number): Promise<any>;
  sync(): Promise<any>;
}

export class CalendarService implements ICalendarService {
  private qubehub: any;
  private controllerName: string = "calendar";

  constructor(accessToken: string) {
    this.qubehub = Apis.qubehub(accessToken);
  }

  async find() {
    try {
      const [status, response] = this.#handleResponse(await this.qubehub.get(this.controllerName));

      for (const arrName in response) {
        if (arrName === "calendars") continue;
        response[arrName].forEach((e: any) => {
          e.start = new Date(e.start);
          e.end = new Date(e.end);
        });
      }

      return response ?? null;
    } catch (err: any) {
      console.log(err);
    }
    return null;
  }

  async insert(
    eTitle: string | null,
    eNotes: string | null,
    startTime: Date,
    endTime: Date,
    isPrimary: boolean | null,
    isConfirmed: boolean | null,
    appointmentId: number | null,
    ids?: {
      clinicId?: number;
      providerId?: number;
    }
  ) {
    try {
      return this.#handleResponse(
        await this.qubehub.post(this.controllerName, {
          eTitle,
          eNotes,
          startTime: Helpers.toOffsetString(startTime),
          endTime: Helpers.toOffsetString(endTime),
          isPrimary,
          isConfirmed,
          appointmentId,
          ...ids,
          // ...(clinicId && { clinicId }),
          // TODO: It's cheating!
          ...(Store.sessionStorage.isProvider() && { clinicId: 3 }),
        })
      );
    } catch (err: any) {
      console.log(err);
    }
    return null;
  }

  async update(
    eId: number,
    eTitle: string | null,
    eNotes: string | null,
    startTime: Date,
    endTime: Date,
    isPrimary: boolean | null,
    isConfirmed: boolean | null,
    appointmentId: number | null
  ) {
    try {
      return this.#handleResponse(
        await this.qubehub.patch(Helpers.interpolateURL(this.controllerName + "/:eId", { eId }), {
          eTitle,
          eNotes,
          startTime: Helpers.toOffsetString(startTime),
          endTime: Helpers.toOffsetString(endTime),
          isPrimary,
          isConfirmed,
          appointmentId,
        })
      );
    } catch (err: any) {
      console.log(err);
    }
    return null;
  }

  async delete(eId: number) {
    try {
      return this.#handleResponse(await this.qubehub.delete(Helpers.interpolateURL(this.controllerName + "/:eId", { eId })));
    } catch (err: any) {
      console.log(err);
    }
    return null;
  }

  // TODO: a temp solution just to sync google calendar events with database
  async sync() {
    try {
      return this.#handleResponse(await this.qubehub.get("google"));
    } catch (err: any) {
      console.log(err);
    }
    return null;
  }

  /**
   * method to handle the response from the API
   * @param {any} response the data retrieved from the API
   * @returns
   */

  #handleResponse(response: any) {
    if (response && response.data) {
      const { status, payload } = response.data;
      if (Enums.EnumResponse.Unauthorized === status) Store.sessionStorage.clear();
      return payload ? [status, payload] : [status, null];
    }
    return [Enums.EnumResponse.None, null];
  }
}
